import { isMinutesJobSettled, type MinutesJobStatus } from '@ai-meeting/shared'
import { ApiError } from '@/services/api'
import { fetchMinutesJob } from '@/services/minutesJobs'
import { wait } from '@/utils/wait'

const FIRST_INTERVAL_MS = 2000
const BACKOFF_FACTOR = 1.5
const MAX_INTERVAL_MS = 15_000

/**
 * Poll an internal meeting minutes job until it succeeds, fails, or expires.
 * Mirrors {@link useMinutesJob} for fire-and-forget work outside React.
 */
export async function pollMinutesJobUntilSettled(jobId: string): Promise<MinutesJobStatus> {
  let interval = FIRST_INTERVAL_MS

  for (;;) {
    try {
      const job = await fetchMinutesJob(jobId)
      if (isMinutesJobSettled(job.status)) return job
    } catch (error) {
      if (error instanceof ApiError && error.status === 404) {
        throw error
      }
    }

    await wait(interval)
    interval = Math.min(interval * BACKOFF_FACTOR, MAX_INTERVAL_MS)
  }
}
